import React from 'react';
import Highlighter from 'react-highlight-words';
import ListSearch from '../list/ListSearch';

const VehicleSearch = props => {
  const renderSuggestion = (suggestion, { query }) => {
    const result = {};

    const style = {
      fontSize: '12px',
    };

    ['itemid', 'Make', 'Model', 'Year', 'Type', 'Customer', 'Customer Name', 'License'].forEach((part) => {
      result[part] = suggestion[part];
      if (result[part]) {
        result[part] = (
          <Highlighter
            autoEscape
            highlightClassName="hl"
            searchWords={query.replace(':', '').split(/\s/)}
            textToHighlight={`${suggestion[part]}`}
          />
        );
      }
    });

    return (
      <div>
        <div><b>{result.itemid}</b> ({result.Type})</div>
        {(result.Year || result.Make || result.Model) && (
          <div style={style}>{result.Year} {result.Make} {result.Model}</div>
        )}
        {(result['Customer Name'] || result.Customer) && (
          <div style={style}>{result['Customer Name']} ({result.Customer})</div>
        )}
        {result.License && (
          <div style={style}>License: {result.License}</div>
        )}
      </div>
    );
  };

  return (
    <ListSearch
      {...props}
      renderSuggestion={renderSuggestion}
    />
  );
};

export default VehicleSearch;
